import(/* webpackMode: "eager", webpackExports: ["MarketingPageShell"] */ "/opt/render/project/src/src/modules/landing/components/MarketingPageShell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/modules/landing/components/ProviderPageContent.tsx");
